import React, { useEffect } from "react";
import companyInfo from "../themes/themes";
import { useLocation } from "react-router";

export default function SetFaviconAndLogo() {
  const location = useLocation();
  const theme = process.env.REACT_APP_THEME;

  useEffect(() => {
    const currentLocation = location.pathname.split("/").map((item) => {
      return "../";
    });
    const favicon = document.getElementById("favicon");
    if (currentLocation.length > 2) {
      favicon["href"] = currentLocation.slice(2) + companyInfo[theme].favicon;
    } else {
      const favicon = document.getElementById("favicon");
      favicon["href"] = companyInfo[theme].favicon;
    }
  }, [location.pathname, theme]);

  return <div />;
}
